import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PestleHelpRows from './PestleHelp.Rows';

const pestleHelpWidth = 800; // this is a fixed value, 72rem + 80px

class PestleHelp extends React.Component {

    static propTypes = {
        riskAngleMatches:      PropTypes.object,
        position:              PropTypes.string,
        autoPosition:          PropTypes.bool,
        parentOverflowHandler: PropTypes.func,
        className:             PropTypes.string
    };

    static defaultProps = {
        position: 'right',
        autoPosition: false
    }

    constructor(props) {
        super(props);
        this.state = {isPestleHelpVisible: false};
        this.togglePestleHelpVisibility = this.togglePestleHelpVisibility.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.popup = null;
    }

    componentDidMount() {
        document.addEventListener("keydown", this.keyPress);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.keyPress);
    }

    togglePestleHelpVisibility() {
        this.props.parentOverflowHandler ? this.props.parentOverflowHandler(this.state.isPestleHelpVisible) : null;
        this.setState({isPestleHelpVisible: !this.state.isPestleHelpVisible});
    }

    getAutoPosition() {
        if (this.trigger) {
            return window.innerWidth > this.trigger.getBoundingClientRect().x + pestleHelpWidth ? 'right' : 'left';
        } else {
            return this.props.position
        }
    }

    keyPress(event) {
        if (this.state.isPestleHelpVisible && event.key == "Escape" || event.key == "Esc" || event.keyCode == 27) {
            this.setState({isPestleHelpVisible: false});
        }
    }

    render() {
        const position = this.props.autoPosition ? this.getAutoPosition() : this.props.position;
        return (

            <span className={this.props.className + ' pestle-help no-print ' + position} >

                <span className="la-Help" onClick={this.togglePestleHelpVisibility} ref={(el) => { this.trigger = el }}></span>

                {
                    this.state.isPestleHelpVisible ?

                        <div className="pestle-help__popup">

                            <div className="pestle-help__popup--overlay"
                                 onClick={this.togglePestleHelpVisibility}></div>

                            <div className="pestle-help__popup--header">
                                <FormattedMessage id="General_CoreFunctionality_UIText_general.riskAngleDefinitions" />
                                <span className="la-CloseRemove" onClick={this.togglePestleHelpVisibility}></span>
                            </div>

                            <div className="pestle-help__popup--body">

                                <div className="row risk-angle-description">
                                    <FormattedMessage
                                        id="General_CoreFunctionality_UIText_general.riskAnglesDescription" />
                                </div>

                                <PestleHelpRows riskAngleMatches={this.props.riskAngleMatches} />

                            </div>

                            <div className={"pestle-help__arrow " + position}></div>
                            <div className={"pestle-help__arrow-mask " + position}></div>

                        </div>
                        :
                        null
                }

            </span>
        )
    }

}

export default PestleHelp;


// WEBPACK FOOTER //
// ./src/scripts/reusable/PestleHelp/PestleHelp.jsx